import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Box, Button } from 'grommet'
import { SharedClassIcon as SharedClassIconBase } from 'secondstep-components'
import GradeTile from 'components/dashboard/GradeTile'
import DropdownMenu from 'components/DropdownMenu'

export const StyledGradeTile = styled(GradeTile)`
  flex-shrink: 0;
`

export const TopSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  flex-shrink: 0;

  & > div {
    margin-right: ${themeGet('spacing.yellow12_0_75rem')};
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 18.4375rem;
  position: relative;
  border-radius: 0.625rem;
  background: ${themeGet('colors.themeAccent')};
`

export const StyledDropdownMenu = styled(DropdownMenu)`
  position: absolute;
  top: 9px;
  left: 90%;
`

export const CardWrapper = styled(Button).attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))`
  width: 100%;
  display: flex;
  flex-direction: ${props => (props.includeProgressBar ? 'column' : 'row')};
  align-items: ${props => (props.includeProgressBar ? 'stretch' : 'center')};
  transition: all 0.2s ease;
  padding: ${themeGet('spacing.yellow12_0_75rem')};
  border-radius: 0.625rem;
  background: ${props =>
    props.tier === 2
      ? themeGet('colors.themeAccent')
      : themeGet('colors.themeDark')};

  ${StyledGradeTile} {
    & > div {
      background: ${props =>
        props.tier === 2
          ? themeGet('colors.themeDark')
          : themeGet('colors.themeAccent')};
    }
  }
  &:hover {
    background: ${themeGet('colors.classCardHover')};
  }

  /* ProgressBar overrides for ClassCard context - scoped to ClassCard only */
  [data-testid='classProgressBar'] {
    padding: 0;
    width: 100%;
    position: relative;
  }

  [data-testid='classProgressBar-background'],
  #classProgressBar-background {
    margin: 0 !important;
    padding: 0 !important;
    height: 0.375rem !important;
    background-color: ${themeGet('colors.progressBar.background')} !important;
    border-radius: 0.375rem !important;
    overflow: hidden !important;
    position: relative !important;
    display: block !important;
  }

  [data-testid='classProgressBar-indicator'],
  #classProgressBar-indicator,
  [data-testid='classProgressBar-background'] > div,
  #classProgressBar-background > div {
    height: 0.375rem !important;
    min-height: 0.375rem !important;
    max-height: 0.375rem !important;
    line-height: 0.375rem !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0.375rem !important;
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    display: block !important;
    vertical-align: top !important;
  }
`

export const InfoBox = styled(Box)`
  color: ${themeGet('colors.white')};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h4 {
    margin-bottom: 0.5rem;
    color: ${themeGet('colors.white')};
    font-size: 1.0625rem;
    line-height: 1.125rem;
    font-family: ${themeGet('fontFamilyBold')};
  }

  span {
    font-style: italic;
  }
`

export const ProgressRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.375rem;
`

export const SharedClassIcon = styled(SharedClassIconBase)`
  width: 0.75rem;
  height: 0.5625rem;
  flex-shrink: 0;
  color: ${({ $isElementary }) => ($isElementary ? '#AD6EE5' : '#E77564')};
`

export const ProgressSection = styled.div`
  position: relative;
  width: 100%;
  margin-top: 0.75rem;
`

export const GoalDot = styled.div.attrs(({ goalPercentage }) => ({
  style: {
    left: `${goalPercentage}%`,
  },
}))`
  position: absolute;
  top: 1px;
  transform: translateX(-50%);
  z-index: 10;
  height: 0.25rem;
  width: 0.25rem;
  background: ${themeGet('colors.themeDark')};
  border-radius: 50%;
`

export const GoalText = styled.span`
  display: block;
  color: ${themeGet('colors.lighterGray')};
  font-size: 0.875rem;
  font-style: italic;
  font-weight: normal;
  font-family: ${themeGet('font.molde.regular')};
  margin-top: 0.75rem;
  padding: 0;
  white-space: nowrap;
  text-align: left;
  line-height: 1.25;
`
